// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterSectionBody":"ServiceFooterSectionBody_ServiceFooterSectionBody__JOhbm"};